import { useContext } from 'react';
import i18n from 'i18n-js';

import { TranslationContext } from '../translation/provider';

const useTranslation = () => {
  const context = useContext(TranslationContext);

  if (context === undefined) {
    throw new Error(
      '`useTranslation` hook must be used within a `TranslationProvider` component'
    );
  }

  return context;
};

export const translated = (
  key: string | string[],
  number?: number
): boolean => {
  let path: string[];
  if (number) {
    path =
      typeof key === 'object'
        ? [number.toString(10), ...key]
        : [number.toString(10), key];
  } else {
    path = typeof key === 'object' ? key : [key];
  }
  const result = i18n.t(path, { defaultValue: '' });
  return result !== '' && typeof result === 'string';
};

export default useTranslation;
